import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuthStore } from '../../store/authStore';
import { User, HelpCircle, LogOut, ChevronDown } from 'lucide-react';

const UserMenu = ({ user, setUser }) => {
  const [isOpen, setIsOpen] = useState(false);
  const { logout } = useAuthStore();
  const menuRef = useRef();

  const toggleMenu = () => setIsOpen((prev) => !prev);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const menuItems = [
    { icon: User, label: 'Profile', to: '/profile' },
    { icon: HelpCircle, label: 'Help', to: '/help' },
  ];

  const loading = !user;

  return (
    <div className="relative" ref={menuRef}>
      <button
        onClick={toggleMenu}
        className="flex items-center space-x-2 px-2 py-1 rounded-full hover:bg-gray-100 transition"
        disabled={loading}
      >
        {loading ? (
          <div className="h-8 w-8 rounded-full bg-gray-300 animate-pulse" />
        ) : (
          <img
            src={user?.avatar || '/default-avatar.png'}
            alt={user?.name}
            className="h-8 w-8 rounded-full object-cover border border-gray-300"
          />
        )}

        <span className="hidden md:block font-medium text-sm">
          {loading ? (
            <span className="w-20 h-4 bg-gray-300 animate-pulse rounded"></span>
          ) : (
            user?.name
          )}
        </span>
        <ChevronDown className="h-4 w-4 text-gray-500" />
      </button>

      {isOpen && (
        <div className="absolute right-0 mt-2 w-60 bg-white border border-gray-100 rounded-lg shadow-lg z-50">
          <div className="px-4 py-3 border-b">
            {loading ? (
              <>
                <div className="w-32 h-4 bg-gray-300 rounded mb-1 animate-pulse"></div>
                <div className="w-40 h-3 bg-gray-200 rounded animate-pulse"></div>
              </>
            ) : (
              <>
                <p className="text-sm font-semibold text-gray-900">{user?.name}</p>
                <p className="text-xs text-gray-500 truncate">{user?.email}</p>
              </>
            )}
          </div>

          <div className="py-1">
            {loading
              ? [1, 2].map((_, i) => (
                  <div
                    key={i}
                    className="px-4 py-2 flex items-center space-x-3 animate-pulse"
                  >
                    <div className="w-4 h-4 bg-gray-300 rounded" />
                    <div className="w-24 h-3 bg-gray-200 rounded" />
                  </div>
                ))
              : menuItems.map((item, index) => (
                  <Link
                    key={index}
                    to={item.to}
                    onClick={() => setIsOpen(false)}
                    className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-50"
                  >
                    <item.icon className="h-4 w-4 mr-3 text-gray-500" />
                    {item.label}
                  </Link>
                ))}
          </div>

          <div className="border-t py-1">
            {loading ? (
              <div className="px-4 py-2 flex items-center space-x-3 animate-pulse">
                <div className="w-4 h-4 bg-gray-300 rounded" />
                <div className="w-20 h-3 bg-gray-200 rounded" />
              </div>
            ) : (
              <button
                onClick={() => {
                  logout();
                  setIsOpen(false);
                }}
                className="flex items-center w-full px-4 py-2 text-sm text-red-600 hover:bg-gray-50"
              >
                <LogOut className="h-4 w-4 mr-3" />
                Sign out
              </button>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default UserMenu;


// import React, { useEffect, useRef, useState } from 'react';
// import { Link } from 'react-router-dom';
// import { useAuthStore } from '../../store/authStore';
// import { User, HelpCircle, LogOut, ChevronDown } from 'lucide-react';
// import axios from 'axios';
// import { host } from '../../api/ApiCalls';

// const UserMenu = ({user, setUser}) => {
//   const [isOpen, setIsOpen] = useState(false);
//   const { logout, token } = useAuthStore();
//   // const [user, setUser] = useState(null);
//   const menuRef = useRef();

//   const toggleMenu = () => setIsOpen((prev) => !prev);

  
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (menuRef.current && !menuRef.current.contains(event.target)) {
//         setIsOpen(false);
//       }
//     };
//     document.addEventListener('mousedown', handleClickOutside);
//     return () => document.removeEventListener('mousedown', handleClickOutside);
//   }, []);

//   const menuItems = [
//     { icon: User, label: 'Profile', to: '/profile' },
//     { icon: HelpCircle, label: 'Help', to: '/help' },
//   ];

//   return (
//     <div className="relative" ref={menuRef}>
//       <button
//         onClick={toggleMenu}
//         className="flex items-center space-x-2 px-2 py-1 rounded-full hover:bg-gray-100 transition"
//       >
//         <img
//           src={user?.avatar || '/default-avatar.png'}
//           alt={user?.name}
//           className="h-8 w-8 rounded-full object-cover border border-gray-300"
//         />
//         <span className="hidden md:block font-medium text-sm">{user?.name}</span>
//         <ChevronDown className="h-4 w-4 text-gray-500" />
//       </button>

//       {isOpen && (
//         <div className="absolute right-0 mt-2 w-60 bg-white border border-gray-100 rounded-lg shadow-lg z-50">
//           <div className="px-4 py-3 border-b">
//             <p className="text-sm font-semibold text-gray-900">{user?.name}</p>
//             <p className="text-xs text-gray-500 truncate">{user?.email}</p>
//           </div>

//           <div className="py-1">
//             {menuItems.map((item, index) => (
//               <Link
//                 key={index}
//                 to={item.to}
//                 onClick={() => setIsOpen(false)}
//                 className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-50"
//               >
//                 <item.icon className="h-4 w-4 mr-3 text-gray-500" />
//                 {item.label}
//               </Link>
//             ))}
//           </div>

//           <div className="border-t py-1">
//             <button
//               onClick={() => {
//                 logout();
//                 setIsOpen(false);
//               }}
//               className="flex items-center w-full px-4 py-2 text-sm text-red-600 hover:bg-gray-50"
//             >
//               <LogOut className="h-4 w-4 mr-3" />
//               Sign out
//             </button>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default UserMenu;
